'use client';

import { Footer } from '@/components/Footer';
import Link from 'next/link';

interface PageTemplateProps {
  title: string;
  children: React.ReactNode;
  showBackButton?: boolean;
}

export function PageTemplate({ title, children, showBackButton = false }: PageTemplateProps) {
  return (
    <main className="min-h-screen bg-gradient-to-b from-violet-50 to-white">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{title}</h1>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            {children}
            {showBackButton && (
              <div className="mt-8 flex justify-center">
                <Link
                  href="/"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-violet-600 hover:bg-violet-700 transition-colors"
                >
                  Back to Home
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
